import React from 'react'; import {createRoot} from 'react-dom/client'; import {BrowserRouter} from 'react-router-dom'; import {QueryClient,QueryClientProvider} from '@tanstack/react-query'; import './styles.css'; import App from './App'; const client=new QueryClient(); createRoot(document.getElementById('root')!).render(<React.StrictMode><QueryClientProvider client={client}><BrowserRouter><App/></BrowserRouter></QueryClientProvider></React.StrictMode>);


// PWA service worker — production only (requires secure context: HTTPS).
// Single guarded controllerchange reload: reloads exactly once when a NEWER
// worker version activates and takes control. updateViaCache: "none" forces
// the browser to always fetch sw.js from the network (skipping HTTP caches),
// so a real script change is detected even when bytes were previously cached.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/sw.js", {
      scope: "/",
      updateViaCache: "none",
    })
    .catch(() => {
      // Never break the app if registration fails.
    });

  let refreshing = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}
